export default __webpack_public_path__ + "static/media/changing_tn.d7cc82c8.jpg";